'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Smashing';

var EntypoSmashing = function EntypoSmashing(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10.023,16.032c-2.508,0-4.253-1.555-4.253-1.555L4.287,17.84c1.023,0.547,2.092,0.936,2.709,1.141l-1.592,0.381c-0.746,0.178-1.496-0.283-1.675-1.029L0.639,5.405C0.46,4.659,0.92,3.909,1.667,3.729L5.383,2.84c-0.91,1.029-1.263,2.252-1.174,3.65c0.139,2.193,2.237,3.879,4.734,4.822C13.644,13.088,12.529,16.032,10.023,16.032z M19.361,14.594L16.27,1.666c-0.178-0.746-0.928-1.207-1.675-1.027l-2.663,0.637c0.679,0.105,2.024,0.4,3.505,1.178l-1.159,3.213c0,0-0.965-1.078-3.553-1.209c-2.46-0.125-3.828,2.537,0.969,4.105c3.674,1.201,4.848,3.516,4.787,5.658c-0.031,1.113-0.421,2.018-0.872,2.701l2.725-0.652C19.08,16.092,19.54,15.342,19.361,14.594z' })
    );
};

exports.default = EntypoSmashing;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/Smashing.js
// module id = 7518
// module chunks = 0